import { Injectable } from '@angular/core';
import { ContentHeaderButton } from '../../models';
import { Subject } from 'rxjs';
import { Router, NavigationEnd, Event } from '@angular/router';

/**
 * Service to control what buttons are shown in Content Header Bars
 *
 * @export
 * @class ContentHeaderBarService
 */
@Injectable()
export class ContentHeaderBarService {
  /**
   * Emits when a button is clicked
   *
   * @memberof ContentHeaderBarService
   */
  onClick = new Subject<ContentHeaderButton>();

  /**
   * The list of buttons to show
   *
   * @type {ContentHeaderButton[]}
   * @memberof ContentHeaderBarService
   */
  buttons: ContentHeaderButton[] = [];

  constructor(private router: Router) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.clearButtons();
      }
    });
  }

  /**
   * Adds buttons. Default is on the right (end)
   *
   * @param {ContentHeaderButton[]} [buttons=[]]
   * @param {boolean} [onLeft=false]
   * @memberof ContentHeaderBarService
   */
  setButtons(buttons: ContentHeaderButton[] = [], onLeft = false) {
    // Is this promise needed? https://stackoverflow.com/a/45113158
    Promise.resolve().then(() => {
      this.clearButtons();
      if (onLeft) {
        this.buttons.unshift(...buttons);
      } else {
        this.buttons.push(...buttons);
      }
    });
  }

  /**
   * Removes all buttons
   *
   * @memberof ContentHeaderBarService
   */
  clearButtons() {
    this.buttons.splice(0, this.buttons.length);
  }
}
